var gForumUrls = {
    'new-comment': '/forum/topic/{id}/comment',
    'new-reply':'/forum/comment/{id}/comment',
    'like-comment':'/forum/comment/{id}/like',
    'get-replies':'/forum/comment/{id}'
};

function ForumController(aUser, aCsrfToken, aComment){
    var self = this;
    self.mUser = aUser;
    self.mCsrfToken = aCsrfToken;
    self.mComment = aComment;

    self.mUrls = {
        'new-comment': '/forum/topic/{id}/comment',
        'new-reply':'/forum/comment/{id}/comment',
        'like-comment':'/forum/comment/{id}/like',
        'get-replies':'/forum/comment/{id}'
    };

    $.ajaxPrefilter(function( options ) {
        if ( !options.beforeSend) {
            options.beforeSend = function (xhr) {
                xhr.setRequestHeader('X-CSRF-Token', self.mCsrfToken);
            }
        }
    });

    self.buildUrl =  function(aUrl, aId){
        return aUrl.replace("{id}", aId);
    };


    self.httpRequest = function(aTargetUrl, aModelId, aType, aData, aSuccess, aBeforeSend){
        if(aBeforeSend){
            aBeforeSend();
        }
        var url = self.buildUrl(aTargetUrl, aModelId);
        $.ajax({
            url:url,
            type:aType,
            data:aData,
            success:function(response){
                if(aSuccess){
                    aSuccess(response.data)
                }
            }
        });
    };

    self.postComment = function(aFourmId, aData){
        self.httpRequest(self.mUrls['new-comment'], aForumId, 'post', aData, function(x){console.log(x);}, null);
    };

    self.postReply = function(aCommentId, aData){
        self.httpRequest(self.mUrls['new-reply'], aCommentId, 'post', aData, function(x){console.log(x);}, null);
    };

    self.likeComment = function(aCommentId){
        self.httpRequest(self.mUrls['like-comment'], aCommentId, 'post', null, function(x){console.log(x);}, null);
    };

    self.getReplies = function(aCommentId){
        self.httpRequest(self.mUrls['get-replies'], aCommentId, 'get', null, function(x){console.log(x);}, null);
    };

}

//Comment Model
function Comment(id, comment, commenter, likes, viewer_id){

    this._id = id;
    this._comment = comment;
    this._commenter = commenter;
    this._likes = likes;
    this._viewer_id = viewer_id;
    this._replies = [];

}
Comment.prototype = {

    setReplies : function(replies){
        this._replies.concat(replies)
    },

    getReplies : function(){
        return [].concat(this._replies)
    },

    setLikes : function() {
        return [].concat(this._likes)
    },

    getLikes : function(){
        return this._likes;
    },

    getComment : function(){
        return this._commenter;
    },

    doesViewerLikeThis : function(){
        $.each(this._likes, function(key,like){
            if(like.user_id == this._viewer_id){
                return true;
            }
        });
        return false;
    }

};

function CommentEvent(sender) {
    this._sender = sender;
    this._listeners = [];
}

CommentEvent.prototype = {
    attach : function (listener) {
        this._listeners.push(listener);
    },
    notify : function (args) {
        var index;

        for (index = 0; index < this._listeners.length; index += 1) {
            this._listeners[index](this._sender, args);
        }
    }
};

function CommentView(model, elements){
    this._model = model;
    this._elements = elements;

    this._commentTemplate =
        '<div class="comment" data-id="{comment_id}">' +
            '<img class="user-photo src=""/>' +
            '<p class="user-text">{user_text}</p>'+
            '<div class="comment-footer">' +
                '<p class="user-name">{user_name}</p>'+
            '</div>'+
            '<i class="fa fa-heart-o heart heartbeat like-btn" data-id="{comment_id}"></i>'+
            '<p class="fav-count">{likes}</p>'+
            '<p class="respond" data-has-comments=""> Comment</p>'+
            '<div class="replies">{replies_count}</div>'+
            '<form class="new-reply postReplyCommentForm" action="/forum/comment/{comment_id}/comment" method="POST">'+
                '<div class="wrapper">'+
                    '<img class="user-photo" src="/images/doctors/doctor.png">'+
                    '<textarea class="user-text" name="comment" id="comment">{comment}</textarea>'+
                '</div>'+
                '<button class="post-comment">Submit</button>'+
            '</form>'+
        '</div>';


    this.showRepliesClicked = new CommentEvent(this);
    this.likeBtnClicked = new CommentEvent(this);

    var _this = this;

    // attach model listeners
    this._model.commentLiked.attach(function () {

    });
    this._model.repliesShown.attach(function () {

    });

    // attach listeners to HTML controls
    this._elements.likeBtn.click(function () {
        _this.likeBtnClicked.notify();
    });
    this._elements.showReplies.click(function () {
        _this.showRepliesClicked.notify();
    });
}

CommentView.prototype = {

    buildReply : function(reply){
        var replyTemplate;

        replyTemplate = this._commentTemplate.replace("{comment_id}", reply.id);
        return replyTemplate;
    },

    showReplies : function(){
        var replies, list;
        replies = this._model.replies;
        list = this._elements.list;
        list.html('');
        $.each(replies, function(key,reply){
            list.append($(this.buildReply(reply)))
        });
    },

    likeComment : function(comment){
        comment.find('.like-btn')
            .removeClass('like-btn')
            .removeClass('fa-heart-o')
            .addClass('fa-heart')
    }


};

function CommentController(model,view,user,token){
    this._model = model;
    this._view = view;
    this._user = user;
    this._token = token;

    this.mUrls = {
        'new-comment': '/forum/topic/{id}/comment',
        'new-reply':'/forum/comment/{id}/comment',
        'like-comment':'/forum/comment/{id}/like',
        'get-replies':'/forum/comment/{id}'
    };

    var _this = this;

    $.ajaxPrefilter(function( options ) {
        if ( !options.beforeSend) {
            options.beforeSend = function (xhr) {
                xhr.setRequestHeader('X-CSRF-Token', self.mCsrfToken);
            }
        }
    });

}

CommentController.prototype = {

    getReplies : function () {

    }

};
